<template>
 <div id="app">
      <SearchParallax />
      <CompanyInfo />
      <ContactParallax />
      <ContactFooter />
 </div>
</template>

<script>
import SearchParallax from '@/components/searchParallax.vue';
import CompanyInfo from '@/components/companyInfo.vue';
import ContactParallax from '@/components/contactParallax.vue';
import ContactFooter from '@/components/contactFooter.vue';

export default {
  name: 'home',
  components: {
    SearchParallax,
    CompanyInfo,
    ContactParallax,
    ContactFooter,
  },
};
</script>

<style>
.mainTitle {
  /* color:#C62828; */
  color: #fff;
  padding-bottom: 20px;
  /* font-weight: lighter; */
}

.secondaryTitle {
  color: #fff;
  padding-bottom: 20px;
  /* font-weight: lighter; */
}

@media (min-width: 1024px) {
  .mainTitle {
    font-size : 45px!important;
  }
}

@media (min-width: 324px) and (max-width: 1023px) {
  .mainTitle {
    font-size : 33px!important;
  }
}
</style>
